export default __webpack_public_path__ + "static/media/ic_instagram.a2018a0a.svg";